var isArrayLike = (function (x) { return x && typeof x.length === 'number' && typeof x !== 'function'; });

export { isArrayLike };
//# sourceMappingURL=isArrayLike.js.map
